import React from 'react';

function SettingsModal({ musicSettings, setMusicSettings, onClose }) {
  // Fallback for musicSettings
  const safeMusicSettings = musicSettings || {
    musicVolume: 0.5,
    sfxVolume: 0.5,
    isMusicEnabled: true,
    isSfxEnabled: true,
    isFpsCounterEnabled: false, // Added FPS counter setting
  };

  const handleMusicVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setMusicSettings((prev) => {
      const updatedSettings = { ...prev, musicVolume: newVolume };
      localStorage.setItem('musicVolume', newVolume.toString());
      return updatedSettings;
    });
  };

  const handleSfxVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setMusicSettings((prev) => {
      const updatedSettings = { ...prev, sfxVolume: newVolume };
      localStorage.setItem('sfxVolume', newVolume.toString());
      return updatedSettings;
    });
  };

  const handleMusicToggle = () => {
    setMusicSettings((prev) => {
      const updatedSettings = { ...prev, isMusicEnabled: !prev.isMusicEnabled };
      localStorage.setItem('isMusicEnabled', updatedSettings.isMusicEnabled.toString());
      return updatedSettings;
    });
  };

  const handleSfxToggle = () => {
    setMusicSettings((prev) => {
      const updatedSettings = { ...prev, isSfxEnabled: !prev.isSfxEnabled };
      localStorage.setItem('isSfxEnabled', updatedSettings.isSfxEnabled.toString());
      return updatedSettings;
    });
  };

  const handleFpsCounterToggle = () => {
    setMusicSettings((prev) => {
      const updatedSettings = { ...prev, isFpsCounterEnabled: !prev.isFpsCounterEnabled };
      localStorage.setItem('isFpsCounterEnabled', updatedSettings.isFpsCounterEnabled.toString());
      return updatedSettings;
    });
  };

  // Log warning if musicSettings is undefined
  React.useEffect(() => {
    if (!musicSettings) {
      console.warn('musicSettings is undefined in SettingsModal, using fallback');
    }
  }, [musicSettings]);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 overflow-auto">
      <div
        className="bg-gradient-to-b from-[#057CC1] to-[#025F94] p-4 rounded-lg shadow-lg w-11/12 max-w-sm max-h-[85vh] relative"
        role="dialog"
        aria-labelledby="settings-modal-title"
      >
        <h2 id="settings-modal-title" className="text-white text-base font-bold mb-3">
          Settings
        </h2>
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <label className="text-white flex items-center text-sm w-1/3">
              <input
                type="checkbox"
                checked={safeMusicSettings.isMusicEnabled}
                onChange={handleMusicToggle}
                className="mr-1 h-4 w-4 rounded accent-cyan-500"
                aria-label="Toggle music"
              />
              Music
            </label>
            <div className="flex-1">
              <label className="text-white text-sm">
                {(safeMusicSettings.musicVolume * 100).toFixed(0)}%
              </label>
              <input
                type="range"
                min="0"
                max="1"
                step="0.01"
                value={safeMusicSettings.musicVolume}
                onChange={handleMusicVolumeChange}
                className="w-full h-2 rounded-lg appearance-none bg-white/30 cursor-pointer"
                aria-label="Music volume control"
              />
            </div>
          </div>
          <div className="flex items-center gap-2">
            <label className="text-white flex items-center text-sm w-1/3">
              <input
                type="checkbox"
                checked={safeMusicSettings.isSfxEnabled}
                onChange={handleSfxToggle}
                className="mr-1 h-4 w-4 rounded accent-cyan-500"
                aria-label="Toggle SFX"
              />
              SFX
            </label>
            <div className="flex-1">
              <label className="text-white text-sm">
                {(safeMusicSettings.sfxVolume * 100).toFixed(0)}%
              </label>
              <input
                type="range"
                min="0"
                max="1"
                step="0.01"
                value={safeMusicSettings.sfxVolume}
                onChange={handleSfxVolumeChange}
                className="w-full h-2 rounded-lg appearance-none bg-white/30 cursor-pointer"
                aria-label="SFX volume control"
              />
            </div>
          </div>
          <div className="flex items-center gap-2">
            <label className="text-white flex items-center text-sm w-1/3">
              <input
                type="checkbox"
                checked={safeMusicSettings.isFpsCounterEnabled}
                onChange={handleFpsCounterToggle}
                className="mr-1 h-4 w-4 rounded accent-cyan-500"
                aria-label="Toggle FPS Counter"
              />
              FPS Counter
            </label>
          </div>
        </div>
        <img
          src="/closeBtn.png"
          alt="Close"
          onClick={onClose}
          className="absolute -top-5 -right-5 w-10 h-10 cursor-pointer hover:opacity-80 transition-opacity duration-300 animate-wobble"
        />
      </div>
    </div>
  );
}

export default SettingsModal;